import { makeStyles } from '@material-ui/core/styles'
import { Theme, MenuItem, Grid } from '@material-ui/core'
import { useIntl } from 'react-intl'
import { specificationItem } from '../ProductsConfiguration'
import LiquidSelect from '@src/components/LiquidSelect'
import LiquidFormLabel from '@src/components/LiquidFormLabel'

const useStyles = makeStyles((theme: Theme) => ({
  dropDown: {
    paddingTop: theme.spacing(2),
  },
}))
interface SpecificationSelectProps {
  list: specificationItem[]
  specificationLabel: React.ReactNode
  specificationValue: string | undefined
  handleChange: (event: React.ChangeEvent<{ value: unknown }>) => void
}

const SpecificationSelect = ({
  list,
  specificationLabel,
  specificationValue,
  handleChange,
}: SpecificationSelectProps) => {
  const classes = useStyles()
  const intl = useIntl()
  return (
    <Grid item xs={4} sm={3} md={3} className={classes.dropDown}>
      <LiquidFormLabel>{specificationLabel}</LiquidFormLabel>
      <LiquidSelect
        value={specificationValue}
        onChange={handleChange}
        displayEmpty
      >
        {[
          {
            key: '',
            value: intl.formatMessage({
              id: 'PC_SPEC_SELECT_antisera',
              defaultMessage: 'Select',
            }),
          },
        ]
          .concat(list)
          .map((item) => (
            <MenuItem key={item.key} value={item.key}>
              {item.value}
            </MenuItem>
          ))}
      </LiquidSelect>
    </Grid>
  )
}

export default SpecificationSelect
